/**
 * Which contract types the figures cover.
 *
 * Time & Material, Software Subscription, Services Subscription and Fixed
 * Price earn in different ways, so a margin blended across all of them answers
 * nobody's question. Defaults to every type -- the unfiltered view is the one
 * most people want, and it is also the only one whose account totals come
 * straight from AccountProfitability rather than being rebuilt from demands.
 */
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/** The value that means "no filter". Not an empty string: an empty value makes
 *  the Select render its placeholder instead of a label. */
export const ALL_CONTRACT_TYPES = "all";

export function ContractTypeSelect({
  types,
  value,
  onChange,
}: {
  types: string[] | undefined;
  value: string;
  onChange: (key: string) => void;
}) {
  const options = types ?? [];
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[190px]" aria-label="Contract type">
        <SelectValue placeholder="All contract types" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL_CONTRACT_TYPES}>All contract types</SelectItem>
        {options.map((type) => (
          <SelectItem key={type} value={type}>
            {type}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
